import { render } from "./Radio.vue?vue&type=template&id=2d357b32&scoped=true"
import script from "./Radio.vue?vue&type=script&lang=js"
export * from "./Radio.vue?vue&type=script&lang=js"

import "./Radio.vue?vue&type=style&index=0&id=2d357b32&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2d357b32"

export default script